import { Clock3, Eraser, ShieldCheck, Star, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { clearPackCache, clearTemporaryTaskData } from '../../features/offline/packManager';
import { clearFavorites, clearToolHistory } from '../../features/preferences/preferences';
import { clearStoredLanguage } from '../../i18n/language';

export function PrivacySettingsPage() {
  const { t } = useTranslation();
  const [clearing, setClearing] = useState(false);
  const [done, setDone] = useState(false);

  const clearAll = async (): Promise<void> => {
    if (!window.confirm(t('settings.privacy.clearAllDescription'))) return;
    setClearing(true);
    try {
      clearFavorites();
      clearToolHistory();
      for (const key of Object.keys(localStorage)) if (key.startsWith('satr:')) localStorage.removeItem(key);
      clearStoredLanguage();
      await Promise.all([clearPackCache(), clearTemporaryTaskData()]);
      setDone(true);
      window.setTimeout(() => window.location.reload(), 800);
    } finally {
      setClearing(false);
    }
  };

  return (
    <section className="settings-section">
      <h2>{t('settings.privacy.title')}</h2>
      <p>{t('settings.privacy.filesStayLocalDescription')}</p>
      <div className="setting-row"><div><strong><ShieldCheck size={16} aria-hidden="true" /> {t('settings.privacy.filesStayLocal')}</strong><small>{t('settings.privacy.filesStayLocalDescription')}</small></div><span className="status-pill" data-tone="positive">{t('common.status.ready')}</span></div>
      <div className="setting-row"><div><strong><Clock3 size={16} aria-hidden="true" /> {t('settings.privacy.recentTools')}</strong><small>{t('settings.privacy.recentToolsDescription')}</small></div><button className="button secondary" type="button" onClick={clearToolHistory}>{t('common.actions.clear')}</button></div>
      <div className="setting-row"><div><strong><Star size={16} aria-hidden="true" /> {t('settings.privacy.favorites')}</strong><small>{t('settings.privacy.favoritesDescription')}</small></div><button className="button secondary" type="button" onClick={clearFavorites}>{t('common.actions.clear')}</button></div>
      <div className="setting-row"><div><strong><Eraser size={16} aria-hidden="true" /> {t('settings.privacy.clearCurrentDocument')}</strong><small>{t('workflow.result.clearDescription')}</small></div><button className="button secondary" type="button" onClick={() => void clearTemporaryTaskData()}>{t('common.actions.clear')}</button></div>
      <div className="setting-row"><div><strong><Trash2 size={16} aria-hidden="true" /> {t('settings.privacy.clearAllData')}</strong><small>{t('settings.privacy.clearAllDescription')}</small></div><button className="button danger" type="button" disabled={clearing} onClick={() => void clearAll()}>{clearing ? t('common.status.loading') : t('settings.privacy.clearAllConfirm')}</button></div>
      {done && <div className="notice info" role="status">{t('settings.privacy.clearAllComplete')}</div>}
    </section>
  );
}
